import gql from "graphql-tag";

export const CREATE_INSURANCE_PLAN_COVERAGE = gql`
  mutation AddInsurancePlanCoverage($data: InsurancePlanCoverageDataInput) {
    addInsurancePlanCoverage(data: $data) {
      id
    }
  }
`;

export const UPDATE_INSURANCE_PLAN_COVERAGE = gql`
  mutation UpdateInsurancePlanCoverage(
    $where: InsurancePlanCoverageWhereInput
    $data: InsurancePlanCoverageDataInput
  ) {
    updateInsurancePlanCoverage(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_INSURANCE_PLAN_COVERAGE = gql`
  mutation DeleteInsurancePlanCoverage(
    $where: InsurancePlanCoverageWhereInput
  ) {
    deleteInsurancePlanCoverage(where: $where) {
      id
    }
  }
`;

const insurancePlanCoverages = {
  CREATE_INSURANCE_PLAN_COVERAGE,
  UPDATE_INSURANCE_PLAN_COVERAGE,
  DELETE_INSURANCE_PLAN_COVERAGE,
};

export default insurancePlanCoverages;
